export default __webpack_public_path__ + "static/conversational_banner-7537d5d77c1265c4745c263c6ae789fd.webp";